import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-transparent text-white flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-2xl mx-auto bg-black/50 backdrop-blur-lg p-8 rounded-xl border border-white/20">
        <h1 className="text-3xl font-bold mb-6 text-center">PRIVACY POLICY – MAKING HEALTH COOL (MHC)</h1>
        <div className="space-y-4 text-left">
          <p>Contact: joao@makinghealthcool.com<br />
            Address: Brigadeiro Faria Lima Avenue 2553, Apt. 112 – Postal Code 01452-000</p>

          <p>This Privacy Policy explains how MHC (“MHC”, “we”, “us”) collects, uses, discloses, and
            safeguards Personal Information when you use our website, mobile app, and concierge
            via WhatsApp (the “Services”). If you do not agree, please do not use the Services.</p>
          <h2 className="text-2xl font-bold mt-6">1. SCOPE AND ROLES</h2>
          <p>MHC acts as a “business”/“controller” for the Personal Information we determine the
            purposes and means of processing. Some partners (e.g., clinics/labs/coaches) may act
            as independent controllers with their own notices.</p>
          <h2 className="text-2xl font-bold mt-6">2. DEFINITIONS</h2>
          <p>“Personal Information” includes information that identifies, relates to, describes, or could
            reasonably be linked to you. “Sensitive Personal Information” includes
            health/biometric/genetic data and other categories defined under applicable state
            privacy laws (e.g., CPRA).</p>
          <h2 className="text-2xl font-bold mt-6">3. CATEGORIES OF PERSONAL INFORMATION WE COLLECT</h2>
          <ul>
            <li>Identifiers: name, email, phone number, device identifiers, IP address.</li>
            <li>Account/Profile: date of birth, profile details.</li>
            <li>Internet/Activity: usage metrics, logs, app version, crash/diagnostics, cookie/SDK
              IDs.</li>
            <li>Communications: messages sent to support or via WhatsApp.</li>
            <li>Commercial: subscription status and transaction metadata (full card data
              handled by providers).</li>
            <li>Geolocation (approximate): country/city inferred from IP (when applicable).</li>
            <li>Health/Fitness (optional): workouts, sleep, biometrics, body composition, lab
              results when you connect Apple Health, Google Fit, Garmin, Strava, Oura, Polar,
              Whoop or partner clinics/labs and provide consent.</li>
          </ul>
          <h2 className="text-2xl font-bold mt-6">4. PURPOSES OF PROCESSING</h2>
          <ul>
            <li>Provide, maintain and secure the Services: account, authentication, L‑Score and
              recommendations, support, fraud prevention and security monitoring.</li>
            <li>Improve the Services: analytics, debugging, quality and performance, research
              and development (preferably with aggregated/anonymous data).</li>
            <li>Communications and marketing: product updates, invitations and offers; where
              permitted by law, we may also engage in interest‑based advertising with opt‑out
              options.</li>
            <li>Legal/compliance: tax/accounting, regulatory obligations and enforcement.</li>
          </ul>
          <p className='mt-6'> Note on health/fitness data: we request explicit consent and comply with platform
            restrictions (e.g., certain prohibitions on advertising or sale). You may revoke consent at
            any time via settings or contact.</p>
          <h2 className="text-2xl font-bold mt-6">5. DISCLOSURES OF PERSONAL INFORMATION</h2>
          <ul>
            <li>Service providers/processors (cloud hosting, databases, analytics/monitoring,
              payments, customer support, WhatsApp BSP) under contractual safeguards.</li>
            <li>Program partners you choose to engage (clinics, labs, coaches, gyms) — many
              are independent controllers with their own policies.</li>
            <li>Governmental/Legal: to comply with law or respond to lawful requests.</li>
            <li>Corporate transactions: in connection with mergers, acquisitions or similar
              events with appropriate protections.</li>
          </ul>
          <h2 className="text-2xl font-bold mt-6">6. COOKIES AND TRACKING</h2>
          <p>We use cookies/SDKs for authentication, security, preferences, analytics and, where
            permitted, interest‑based advertising. Manage cookies via our banner and your browser.
            Where required by state law, we honor **Global Privacy Control (GPC)** signals.</p>
          <h2 className="text-2xl font-bold mt-6">7. YOUR PRIVACY RIGHTS (STATE LAWS)</h2>
          <p>Depending on your state (e.g., California CPRA, Colorado, Connecticut, Virginia), you may
            have rights to Know/Access, Delete, Correct, Portability, and to Opt Out of (i) targeted
            advertising, (ii) sale or “sharing” of Personal Information, and (iii) profiling in furtherance
            of decisions producing legal or similarly significant effects. You may also **limit** the
            use/disclosure of **Sensitive Personal Information** where applicable.<br />
            How to exercise: email joao@makinghealthcool.com.<br />
            We may verify your request and you may designate an authorized agent.<br />
            We will not discriminate against you for exercising rights.<br />
            Appeals: If we deny your request (where applicable by law), you may appeal by replying
            to our decision email; we will inform you of the outcome and how to contact your state
            Attorney General if you disagree.</p>
          <h2 className="text-2xl font-bold mt-6">8. RETENTION</h2>
          <p>We retain Personal Information only as long as necessary for the purposes described
            above and to meet legal obligations. Afterwards, we delete or de‑identify it.</p>
          <h2 className="text-2xl font-bold mt-6">9. INTERNATIONAL TRANSFERS</h2>
          <p>We may process/store data outside your state or country. Where required, we use
            contractual and technical safeguards.</p>
          <h2 className="text-2xl font-bold mt-6">10. SECURITY</h2>
          <p>We implement administrative, technical, and physical safeguards, including encryption in
            transit and at rest, role‑based access controls, audit logging, vulnerability management,
            and incident response procedures. No method is 100% secure; if a significant incident
            occurs, we will notify you consistent with applicable law.</p>
          <h2 className="text-2xl font-bold mt-6">11. CHILDREN’S PRIVACY</h2>
          <p>The Services are not directed to children under 13 (or under 16 where applicable). We do
            not knowingly collect their data. Parents/guardians may contact us to request deletion.</p>
          <h2 className="text-2xl font-bold mt-6">12. MARKETING, “SALE”/“SHARE”, AND OPT‑OUTS</h2>
          <p>We may use Personal Information for marketing communications and—where permitted
            by law—participate in interest‑based advertising, including sharing data with
            advertising/analytics partners for such purposes. You may opt out of marketing at any
            time and request an opt‑out from activities defined as “sale” or “sharing” under state
            laws via our cookie controls, GPC signals (where honored), or by contacting
            joao@makinghealthcool.com. If required by law, we will display a prominent **“Do Not
            Sell or Share My Personal Information”** link.</p>
          <h2 className="text-2xl font-bold mt-6">13. Strava Integration</h2>
          <p>When you connect your Strava account to Making Health Cool, we collect the following data:</p>
          <p className='mt-6'>Data Collected:</p>
          <ul>
            <li>Activity type, date, and duration</li>
            <li>Average heart rate (if available)</li>
            <li>Normalized Power for cycling activities</li>
            <li>Distance and elevation gain</li>
            <li>Your Strava athlete name and ID</li>
          </ul>
          <p className='mt-6'>How We Use This Data:</p>
          <ul>
            <li>Calculate Training Stress Score (TSS) for load management</li>
            <li>Generate personalized training recommendations</li>
            <li>Identify patterns between workouts and recovery</li>
          </ul>
          <p className='mt-6'>Data Retention:</p>
          <ul>
            <li>Detailed activity data: 30 days</li>
            <li>Aggregated TSS summaries: Indefinitely (required for training load calculation)</li>
          </ul>
          <p className='mt-6'>Your Rights:</p>
          <ul>
            <li>Revoke Strava access anytime via WhatsApp command "Disconnect Strava" or at https://www.strava.com/settings/apps</li>
            <li>Request full data deletion via "Delete my data" command</li>
            <li>We will delete all Strava data within 24 hours of revocation</li>
          </ul>
          <p className='mt-6'>Third-Party Access:</p>
          <p>Your Strava data is processed according to:</p>
          <ul>
            <li>Strava's Privacy Policy: https://www.strava.com/legal/privacy</li>
            <li>Strava API Agreement: https://www.strava.com/legal/api</li>
          </ul>
          <p className='mt-6'>Making Health Cool is not affiliated with, endorsed by, or sponsored by Strava.</p>
          <h2 className="text-2xl font-bold mt-6">14. CHANGES TO THIS POLICY</h2>
          <p>We may update this Policy and will post the new “Last updated” date and any additional
            steps required by law.</p>
          <p className='mt-6'>Contact: joao@makinghealthcool.com</p>
          <p className='mt-6'>Address: Brigadeiro Faria Lima Avenue 2553, Apt. 112 – Postal Code 01452-000</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
